"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddProductTreeNode = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const useAddProductTreeNode = () => {
    const [addProductTreeNodeMutation, data] = (0, react_2.useMutation)(gql_1.ADD_PRODUCT_TREE_NODE);
    const addProductTreeNode = (0, react_1.useCallback)((...args) => addProductTreeNodeMutation(...args), [addProductTreeNodeMutation]);
    return Object.assign({ addProductTreeNode }, data);
};
exports.useAddProductTreeNode = useAddProductTreeNode;
